import { csiAPI } from "src/boot/axios"
import { CSIurl } from "src/util/enums/urls"
import { concatUrl, getCustomConfig, getNewAbortHandler } from "src/util/http/httpHelper"
import { ObjectList } from "src/util/types/dataModels/genericObject"
import { HttpConfig } from "src/util/types/dataModels/http"
import { PERMISSION_ACCESS_READ, PERMISSION_WORK_DOMAINS } from "src/util/types/dataModels/user"
import { WorkDomainFilterParams, WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"

/**
 * Return the list of all the Work Domains
 *
 * @param config custom configurations and filtering params
 */
export async function getWorkDomainsWorkspaceList(
  config: HttpConfig<WorkDomainFilterParams> = {}
): Promise<ObjectList<WorkDomainWorkspace>> {
  const entityURL = CSIurl.WORK_DOMAINS
  const url = concatUrl(entityURL, { ...config?.mainParams, ...config?.filterParams })
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", entityURL)
  const customConfig = getCustomConfig(
    abortHandler,
    PERMISSION_WORK_DOMAINS,
    PERMISSION_ACCESS_READ
  )
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.get(url, { signal, customConfig })

  return data
}

export async function getWorkDomainWorkspace(
  config: HttpConfig = {},
  id: string
): Promise<WorkDomainWorkspace> {
  const url = CSIurl.WORK_DOMAINS_ID.replace("{id}", id)
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", url)
  const customConfig = getCustomConfig(
    abortHandler,
    PERMISSION_WORK_DOMAINS,
    PERMISSION_ACCESS_READ
  )
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.get(url, { signal, customConfig })

  return data
}
